import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'

const useCommonEmblaCarousel = () => {
  const emblaProps = useEmblaCarousel(
    { loop: true, align: 'start', skipSnaps: true },
    [Autoplay()],
  )

  return emblaProps
}

export default useCommonEmblaCarousel
